module.exports = __webpack_public_path__ + "img/girl.671ff10b.png";